import { render } from "./ArrowUp.vue?vue&type=template&id=8750fd92&scoped=true"
import script from "./ArrowUp.vue?vue&type=script&lang=js"
export * from "./ArrowUp.vue?vue&type=script&lang=js"

import "./ArrowUp.vue?vue&type=style&index=0&id=8750fd92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8750fd92"]])

export default __exports__